// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ECTDtxA24OBVMB2QkAgdD"};